import { ChangeDetectorRef } from "@angular/core";
import { TemplateRef } from "@angular/core";
import { ContentChild } from "@angular/core";
import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";

@Component({
    templateUrl: './offcanvas.component.html',
    styleUrls: ['./offcanvas.component.scss'],
    selector: 'uvx-offcanvas'
})
export class OffcanvasComponent implements OnInit, OnDestroy {

    @ContentChild(TemplateRef) offcanvasBody: TemplateRef<any>;

    @Input() title: string = 'Details';

	@ViewChild('offCanvas') 
	public offCanvas: any;

    displayOffcanvas: boolean = false;

    constructor(private offcanvasService: NgbOffcanvas, private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }

	open() {
        var start = performance.now();

        console.log("Open offcanvas")

        // Handle possible null reference
        if(!this.offCanvas) {
            console.error("Offcanvas is not defined");
            return;
        }
		var ref = this.offcanvasService.open(this.offCanvas, { animation: false, ariaLabelledBy: 'offcanvas-basic-title', position:'bottom' });
        // When the canvas is shown
        ref.shown.subscribe(_ => {
            this.displayOffcanvas = true
            var end = performance.now();
            console.log("Open offcanvas took " + (end - start) + " milliseconds.");
            console.log("Body: ", this.offcanvasBody);
        });

        // On close event
        ref.result.then(
			(result) => {
                console.log("Result")
                this.displayOffcanvas = false;
			},
			(reason) => {
                console.log("Reason")
				this.displayOffcanvas = false;
			},
		);
	}



}
